var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBank(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.10547 12.5928H26.0848V29.0774H6.10547V12.5928Z",
    fill: "#475F84"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.92969 11.9443H30.0643V13.2403H1.92969V11.9443Z",
    fill: "#DBD8DD"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M2.47656 27.9722H29.5236V30.1817H2.47656V27.9722Z",
    fill: "#DBD8DD"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M1.20703 29.7407H30.7906V32.0002H1.20703V29.7407Z",
    fill: "#EEEFEE"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M15.9984 0L0.0351562 11.9446H31.9617L15.9984 0Z",
    fill: "#EEEFEE"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M3.70703 10.6246L16.0001 1.37695L28.2928 10.6246H3.70703Z",
    fill: "#DBD8DD"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M4.19922 14.6177H8.01813V26.6442H4.19922V14.6177Z",
    fill: "#DBD8DD"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M3.53125 13.2407H8.68245V14.3787C8.68245 14.6502 8.46232 14.8704 8.19074 14.8704H4.02296C3.75139 14.8704 3.53125 14.6502 3.53125 14.3787V13.2407Z",
    fill: "#EEEFEE"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M4.02413 26.3916H8.19073C8.46231 26.3916 8.68244 26.6117 8.68244 26.8833V27.9725H3.53125V26.8837C3.53104 26.6122 3.75097 26.3918 4.02254 26.3916H4.02413Z",
    fill: "#E4E7E7"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M14.0898 14.6177H17.9088V26.6442H14.0898V14.6177Z",
    fill: "#DBD8DD"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M13.4219 13.2407H18.5731V14.3787C18.5731 14.6502 18.3529 14.8704 18.0814 14.8704H13.9139C13.6424 14.8704 13.4222 14.6502 13.4222 14.3787V13.2407H13.4219Z",
    fill: "#EEEFEE"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M13.914 26.3916H18.081C18.3526 26.3916 18.5727 26.6117 18.5727 26.8833V27.9725H13.4219V26.8837C13.4217 26.6122 13.6416 26.3919 13.9132 26.3916H13.914Z",
    fill: "#E4E7E7"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M23.9805 14.6177H27.7994V26.6442H23.9805V14.6177Z",
    fill: "#DBD8DD"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M23.3125 13.2407H28.4637V14.3787C28.4637 14.6502 28.2436 14.8704 27.972 14.8704H23.8042C23.5326 14.8704 23.3125 14.6502 23.3125 14.3787V13.2407Z",
    fill: "#EEEFEE"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M23.805 26.3916H27.972C28.2436 26.3916 28.4637 26.6117 28.4637 26.8833V27.9725H23.3125V26.8837C23.3123 26.6122 23.5322 26.3918 23.8038 26.3916H23.805Z",
    fill: "#E4E7E7"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M17.6117 5.27436C17.612 6.16382 16.891 6.88507 16.0016 6.88528C16.0003 6.88528 15.999 6.88528 15.9976 6.88528C15.1092 6.8823 14.3897 6.16278 14.3867 5.27436C14.3873 4.38448 15.1091 3.66351 15.999 3.66406C16.869 3.66462 17.5815 4.35565 17.6086 5.2252C17.6119 5.24138 17.6129 5.2579 17.6117 5.27436Z",
    fill: "#475F84"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBank);
export default __webpack_public_path__ + "static/media/bank.0a957ef30cd65ec017586ee2925a6aef.svg";
export { ForwardRef as ReactComponent };